/* eslint-disable import/no-extraneous-dependencies */

import { GridColDef } from '@mui/x-data-grid';
import { BrowseView, browseViewColumnAction } from '@pro4-erp/core-web';
import { Edit as EditIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuditorCompetence, CompetenceType, StatusChip } from '@/common';
import { getAuditorCompetencesForMe } from '../api/getAuditorCompetencesForMe';
import { getBeautifiedLocalDate } from '@/core';

const BrowsePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const columns: GridColDef<AuditorCompetence>[] = [
    {
      ...browseViewColumnAction({
        field: 'actions',
        headerName: t('Open', { defaultValue: 'Open' }),
        icon: {
          element: <EditIcon />,
          color: 'primary',
        },
        onClick: ({ params }) => navigate(`/auditor-competences/${params.id}`),
      }),
      display: 'flex',
    },
    {
      field: 'type.typeShowAs',
      display: 'flex',
      headerName: t('Type', { defaultValue: 'Type' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      sortable: false,
      valueGetter(_, row) {
        return `${row?.type?.typeShowAs || ''} (${row?.type?.subTypeShowAs || ''})`;
      },
    },
    {
      field: 'name',
      display: 'flex',
      headerName: t('Name', { defaultValue: 'Name' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
    },
    {
      field: 'status',
      display: 'flex',
      headerName: t('Status', { defaultValue: 'Status' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => {
        if (params.row.status) {
          return (
            <StatusChip
              codeId={params.row.status.codeId}
              name={params.row.status.name || ''}
              color={params.row.status.color}
            />
          );
        }
        return <>N/A</>;
      },
    },
    {
      field: 'confirmDat',
      display: 'flex',
      headerName: t('Status change date', { defaultValue: 'Status change date' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      valueGetter(_, row) {
        return row.confirmDat ? getBeautifiedLocalDate(row.confirmDat) : 'N/A';
      },
    },
    {
      field: 'validFrom',
      display: 'flex',
      headerName: t('Valid from', { defaultValue: 'Valid from' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      valueGetter(_, row) {
        return row.validFrom ? getBeautifiedLocalDate(row.validFrom) : 'N/A';
      },
    },
    {
      field: 'validTo',
      display: 'flex',
      headerName: t('Valid to', { defaultValue: 'Valid to' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      valueGetter(_, row) {
        return row.validTo ? getBeautifiedLocalDate(row.validTo) : 'N/A';
      },
    },
  ];

  return (
    <BrowseView
      title={
        <BrowseView.Title>{t('Competences', { defaultValue: 'Competences' })}</BrowseView.Title>
      }
      browserViewContainerSx={{
        height: '100vh',
      }}
      columns={columns}
      fetchData={getAuditorCompetencesForMe}
      toolbar={<BrowseView.Toolbar showSearch showDensityBtn />}
      onAddRowClick={() => navigate('/auditor-competences/new')}
    />
  );
};

export default BrowsePage;
